import {secureFetch} from "./authService";
import {API_BASE_URL} from "./constants";

export function saveLoanBankProperty(property) {
    return secureFetch(API_BASE_URL + `/loan/bank/property`, {
        method: 'POST',
        body: JSON.stringify(property)
    });
}

export function updateLoanBankProperty(property) {
    return secureFetch(API_BASE_URL + `/loan/bank/property/${property.id}`, {
        method: 'PUT',
        body: JSON.stringify(property)
    });
}


// WEBPACK FOOTER //
// ./src/helpers/loanBankPropertyService.js